import { SkippedScreening } from 'types/skippedScreening';

const SKIPPED = 'skipped';

/**
 * Skip events for a whole country, such as a package that excludes it from an
 * international search. Only the screening named in `screeningTypes` renders
 * its own skips, so county level events stay with County Searches.
 */
export const getSkippedCountries = (
  skippedScreenings: null | SkippedScreening[] | undefined,
  screeningTypes: readonly string[],
): SkippedScreening[] =>
  (skippedScreenings || []).filter(
    ({ action, country, screeningType }) =>
      action === SKIPPED &&
      Boolean(country) &&
      screeningType != null &&
      screeningTypes.includes(screeningType),
  );

export default getSkippedCountries;
